module.exports = __webpack_public_path__ + "static/media/bg-campaign-hero-03-mobile.e94196a7.jpg";